import React, { useState } from 'react';
import { Form, message } from 'antd';
import { bubbleSpriteApi } from 'apis/platform/bubbleSpriteApis';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneImage from 'components/dropzoneUpload/DropZoneImage';
import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 이미지 등록
 */

const SpriteRegisterModal = (props) => {
  const { t } = useTranslation();
  const { fetchData, visible, setVisible, templateDropdownList } = props;
  const [file, setFile] = useState(null); // 이미지 첨부 파일
  const [imageName, setImageName] = useState();
  const [selectTemplate, setSelectTemplate] = useState('talk'); // 템플릿 데이터
  const [form] = Form.useForm();

  // 모달 창 닫기
  const handleClose = () => {
    setVisible(false);
    setFile(null);
    form.resetFields();
  };

  /// 이름 인풋
  const handleNameChange = (e) => {
    setImageName(e.target.value);
  };

  /// 템플릿 드롭다운
  const handleTemplateChange = (e) => {
    setSelectTemplate(e);
  };

  /// 서버 전송
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('image_name', imageName);
    formData.append('template', selectTemplate);
    formData.append('uploadFile', file);

    await bubbleSpriteApi.register(formData);
    setVisible(false);
    fetchData();
    setFile(null);
    form.resetFields();
    message.success(t('sprite.addSpeechBubbleImageModal.sucscessMessage'), 1);
  };

  return (
    <>
      <DefaultModal
        title={t('sprite.addSpeechBubbleImageModal.title')}
        visible={visible}
        onCancel={handleClose}
        footer={
          <DefaultButton onClick={handleSubmit}>
            {t('sprite.addSpeechBubbleImageModal.register')}
          </DefaultButton>
        }
      >
        <DefaultForm form={form}>
          <DefaultInput
            title={t('sprite.addSpeechBubbleImageModal.inputTitle')}
            allowClear
            placeholder={t('sprite.addSpeechBubbleImageModal.inputPlaceHolder')}
            maxLength='35'
            onChange={handleNameChange}
            // value={imageName}
          />
          <DefaultSelect
            title={t('sprite.addSpeechBubbleImageModal.template')}
            placeholder='템플릿을 입력해주세요'
            optionList={templateDropdownList}
            onChange={handleTemplateChange}
            value={selectTemplate}
            showSearch={false}
          />
          <Form.Item name='uploadFile'>
            <DropZoneImage setFile={setFile} width={100} height={100} />
          </Form.Item>
        </DefaultForm>
      </DefaultModal>
    </>
  );
};
export default SpriteRegisterModal;
